<template>
    <div class="ticket-type">
        <div class="order-info">
            <div class="session-info">
                <div class="order-item-img">
                    <img class="img"
                         :src="detail.pic">
                </div>
                <div class="order-item-content">
                    <div class="film-name">{{detail.filmName}}</div>
                    <div class="time">{{detail.showDateOfChinese}} {{detail.movieInformation}}</div>
                    <div class="cinema-name">{{detail.cinemaName}}</div>
                    <div class="hall-name">{{detail.hallName}}</div>
                </div>
            </div>
            <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="seat-info">
                <div class="line">
                    <div class="key">座位</div>
                    <div class="value">
                        {{detail.seats && detail.seats.map(v=>{ return v.name}).join(';') }}
                    </div>
                </div>
                <div class="line">
                    <div class="key">座位备选</div>
                    <div class="value">
                        {{detail.acceptAdjust ? '同意调座' : '不同意调座'}}
                    </div>
                </div>
            </div>
        </div>
        <div class="ticket-type-box">
            <div class="title">购票方式</div>
            <div class="ticket-type-item"
                 :class="{'no-select' : !status.preferential}"
                 @click="clickChoose(0,status.preferential)">
                <img class="status-img"
                     :src="require(chooseIndex == 0 ? '@/assets/icons/icon-choose.png' : '@/assets/icons/icon-unchoose.png')" />
                <div class="line">
                    <div class="name">特惠购票</div>
                    <div class="price"><span class="text">¥{{qzPrice || '--.--'}}</span></div>
                </div>
                <div class="line">
                    <div class="characteristic">限量抢票</div>
                    <div class="characteristic">出票成功率95%</div>
                    <div class="characteristic">排队中可退改签</div>
                </div>
                <!-- <div class="51-tip">
                    51档热映期间，出票时间可能延长至60分钟出票，请耐心等待。
                </div> -->
                <div class="tip">
                    <div class="line">优惠大但耗时，适合<span class="text">时间充裕</span>提前购票用户</div>
                    <div class="line">平均出票时间20分钟，<span class="text">排队中</span>可随时取消</div>
                    <div class="line">出单中和已出票的订单<span class="text">不可改签、退款</span>，未出票原路退回</div>
                </div>
            </div>
            <div class="ticket-type-item"
                 :class="{'no-select' : !status.directPurchase}"
                 @click="clickChoose(1,status.directPurchase)">
                <img class="status-img"
                     :src="require(chooseIndex == 1 ? '@/assets/icons/icon-choose.png' : '@/assets/icons/icon-unchoose.png')" />
                <div class="line">
                    <div class="name">极速出票</div>
                    <div class="price"><span class="text">¥{{qmmPrice}}</span></div>
                </div>
                <div class="line">
                    <div class="characteristic">限量抢票</div>
                    <div class="characteristic">出票成功率95%</div>
                    <!-- <div class="characteristic">排队中可退改签</div> -->
                </div>
                <div class="tip">
                    <div class="line">适合着急、临场用户</div>
                    <div class="line">实时锁座，方便快捷，折扣优惠</div>
                    <div class="line">出单中和已出票的订单<span class="text">不可改签、退款</span>，未出单<span class="text">15分钟退回</span></div>
                </div>
            </div>
        </div>
        <div class="footer iphone-x-adaptation flex">
            <span class="btn"
                  @click="submit">
                我选好了
            </span>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import { GET_ORDER_INFO, GET_QMM_PRICE, UPDATE_ORDER_DRAW_MODE, GET_ORDER_INFO_FOR_ORDER_NO } from 'api';
    import { PAGE_PAY, PAGE_MOVIE_SEAT_SELECTION } from 'page';
    export default {
        data() {
            return {
                id: 0,
                orderNo: 0,
                detail: {},
                chooseIndex: -1,
                qzPrice: '--.--',
                qmmPrice: '--.--',
                status: {
                    preferential: !true,
                    directPurchase: true
                },
                ecm: true,
                efdm: true,
                cmri: 0,
                dcmt: 0,
            }
        },
        computed: {
            stopSellMinuteOfSelfText() {
                return this.$store.state.common.config && this.$store.state.common.config.stopSellMinuteOfSelfText;
            }
        },
        watch: {
            stopSellMinuteOfSelfText(val) {
                if (!this.ecm) {
                    this.showEcmToast();
                }
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.path == PAGE_MOVIE_SEAT_SELECTION || !vm.id) {
                    vm.init();
                }
            });
        },
        methods: {
            init() {
                this.id = this.$route.query.orderId;
                this.orderNo = this.$route.query.orderNo;
                this.ecm = JSON.parse(this.$route.query.ecm || 'false');
                this.efdm = JSON.parse(this.$route.query.efdm || 'true');
                this.dcmt = this.$route.query.dcmt;
                this.cmri = this.$route.query.cmri;
                if (!this.ecm) {
                    this.showEcmToast();
                }
                this.getOrderInfo();
                this.getQMMprice();

            },
            // 拓展方法
            clickExpand(name) {
                if (name == 'QiShiKa' && this.$store.getters.getExposeMethod.recurrenceConfirmOption) {
                    this.$confirm.open(this.$store.getters.getExposeMethod.recurrenceConfirmOption)
                }
            },
            // 获取订单信息
            getOrderInfo() {
                if (this.orderNo) {
                    this.$util.get(GET_ORDER_INFO_FOR_ORDER_NO, {
                        orderNo: this.orderNo
                    }).then(res => {
                        this.orderInfoResNext(res);
                    })
                }
                else if (this.id) {
                    this.$util.get(`${GET_ORDER_INFO}/${this.id}`).then(res => {
                        this.orderInfoResNext(res);
                    })
                }
            },
            orderInfoResNext(res) {
                if (res.success) {
                    res.data.movieInformation = moment(res.data.showTime).format('M月D日 HH:mm') + ' ' + res.data.versionTypes;
                    this.detail = res.data;
                    if (!this.ecm) {
                        this.status.preferential = false;
                    }
                    else {
                        this.status.preferential = true;
                    }
                    let i = 0;
                    for (let k in this.status) {
                        if (this.status[k]) {
                            break;
                        }
                        else {
                            i++;
                        }
                    }
                    this.chooseIndex = i;
                }
            },
            // 拉去趣满满价格
            getQMMprice() {
                this.$util.post(GET_QMM_PRICE, {
                    orderId: this.id,
                    orderNo: this.orderNo,
                }).then(res => {
                    if (res.success) {
                        this.qmmPrice = res.data.settlePrice;
                        this.qzPrice = res.data.selfPrice;
                    }
                })
            },
            // 切换模式
            clickChoose(index, status) {
                if (!status && index == 0) {
                    this.showEcmToast();
                    return;
                }
                this.chooseIndex = index;
            },
            showEcmToast() {
                if (this.dcmt == 1 && this.stopSellMinuteOfSelfText) {
                    this.$toast(`特惠抢票，请最少提前${this.$store.state.common.config.stopSellMinuteOfSelfText}！！！`, 3000)
                }
                else if (this.dcmt == 2) {
                    this.$toast(`特惠票已抢光，非精品影院每${this.cmri}分钟释放一批折扣票，建议选择精品影院购票。`, 3000);
                }
            },
            // 选好提交
            submit() {
                this.$util.post(UPDATE_ORDER_DRAW_MODE, {
                    orderId: this.detail.id,
                    drawMode: this.chooseIndex == 0 ? 0 : 5
                }).then(res => {
                    if (res.success) {
                        this.$util.pageJump(PAGE_PAY, {
                            // orderId: this.id,
                            orderNo: this.orderNo
                        })
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    @import url('~@/lib/base.less');
    .ticket-type {
        width: 100%;
        padding-bottom: .pxToRem(120) [];
        box-sizing: border-box;
        .order-info {
            background: white;
            margin: .pxToRem(20) [] .pxToRem(30) [];
            border-radius: .pxToRem(40) [];
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
            .session-info {
                display: flex;
                padding: .pxToRem(40) [] .pxToRem(30) [];
                .order-item-img {
                    width: .pxToRem(160) [];
                    height: .pxToRem(210) [];
                    border-radius: .pxToRem(16) [];
                    overflow: hidden;
                    .img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .order-item-content {
                    flex: 1;
                    margin-left: .pxToRem(30) [];
                    .film-name {
                        line-height: .pxToRem(44) [];
                        font-size: .pxToRem(40) [];
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.9);
                        margin-bottom: .pxToRem(48) [];
                    }
                    .time,
                    .cinema-name,
                    .hall-name {
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        color: rgba(0, 0, 0, 0.9);
                    }
                }
            }
            .dividing-line {
                height: .pxToRem(40) [];
                .line-item {
                    .base-center;
                    width: .pxToRem(630) [];
                    height: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.15);
                }
                &::before {
                    content: ' ';
                    .base-center-y;
                    left: 0;
                    height: .pxToRem(36) [];
                    width: .pxToRem(18) [];
                    background: #ececec;
                    border-top-right-radius: .pxToRem(18) [];
                    border-bottom-right-radius: .pxToRem(18) [];
                }
                &::after {
                    content: ' ';
                    .base-center-y;
                    right: 0;
                    height: .pxToRem(36) [];
                    width: .pxToRem(18) [];
                    background: #eeeeee;
                    border-top-left-radius: .pxToRem(18) [];
                    border-bottom-left-radius: .pxToRem(18) [];
                }
            }
            .seat-info {
                padding-bottom: .pxToRem(20) [];
                padding-left: .pxToRem(30) [];
                padding-right: .pxToRem(30) [];
                .line {
                    display: flex;
                    height: .pxToRem(60) [];
                    line-height: .pxToRem(60) [];
                    font-size: .pxToRem(28) [];
                    .key {
                        color: rgba(0, 0, 0, 0.9);
                    }
                    .value {
                        flex: 1;
                        text-align: right;
                        color: rgba(0, 0, 0, 0.5);
                    }
                }
            }
        }
        .ticket-type-box {
            padding-top: .pxToRem(10) [];
            padding-left: .pxToRem(30) [];
            padding-right: .pxToRem(30) [];
            .title {
                padding: .pxToRem(20) [] .pxToRem(30) [];
                font-size: .pxToRem(28) [];
                font-weight: bold;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(40) [];
            }
            .ticket-type-item {
                background: white;
                border-radius: .pxToRem(40) [];
                margin-bottom: .pxToRem(20) [];
                padding: .pxToRem(25) [] .pxToRem(30) [];
                box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
                .status-img {
                    position: absolute;
                    top: .pxToRem(30) [];
                    right: .pxToRem(22) [];
                    width: .pxToRem(44) [];
                    height: .pxToRem(45) [];
                }
                .tip {
                    margin-top: .pxToRem(30) [];
                    .line {
                        display: block;
                        line-height: .pxToRem(36) [];
                        color: rgba(0, 0, 0, 0.5);
                        font-size: .pxToRem(24) [];
                    }
                }
                .line {
                    .text {
                        font-weight: bold;
                        color: #d90209;
                    }
                    .name {
                        line-height: .pxToRem(40) [];
                        font-size: .pxToRem(30) [];
                        color: rgba(0, 0, 0, 0.9);
                    }
                    .price {
                        margin-left: .pxToRem(32) [];
                        font-size: .pxToRem(22) [];
                        color: rgba(0, 0, 0, 0.3);
                        .text {
                            font-size: .pxToRem(36) [];
                            line-height: .pxToRem(36) [];
                            margin-right: .pxToRem(10) [];
                        }
                    }
                    .characteristic {
                        margin-top: .pxToRem(15) [];
                        margin-right: .pxToRem(10) [];
                        padding: 0 .pxToRem(16) [];
                        box-sizing: border-box;
                        height: .pxToRem(34) [];
                        line-height: .pxToRem(34) [];
                        border: .pxToRem(2) [] solid rgba(0, 0, 0, 1);
                        border-radius: .pxToRem(8) [];
                        font-size: .pxToRem(20) [];
                        &:nth-child(1) {
                            color: #f7b500;
                            border-color: #f7b500;
                        }
                        &:nth-child(2) {
                            color: #49c376;
                            border-color: #49c376;
                        }
                        &:nth-child(3) {
                            color: rgba(0, 0, 0, 0.9);
                            border-color: rgba(0, 0, 0, 0.9);
                        }
                    }
                }
                > .line {
                    display: flex;
                    align-items: flex-end;
                }
                &.no-select {
                    // -webkit-filter: grayscale(100%);
                    // -moz-filter: grayscale(100%);
                    // -ms-filter: grayscale(100%);
                    // -o-filter: grayscale(100%);
                    // filter: grayscale(100%);
                    // filter: gray;
                    * {
                        color: #c7c7c7 !important;
                        border-color: #c7c7c7 !important;
                    }
                }
            }
        }
        .footer {
            position: fixed;
            bottom: 0;
            height: .pxToRem(100) [];
            background: rgba(255, 255, 255, 1);
            padding-left: .pxToRem(40) [];
            padding-right: .pxToRem(40) [];
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
            .btn {
                width: .pxToRem(670) [];
                height: .pxToRem(80) [];
                line-height: .pxToRem(80) [];
                text-align: center;
                background: @theme_color_first;
                border-radius: .pxToRem(80) [];
                font-size: .pxToRem(28) [];
                color: rgba(0, 0, 0, 0.9);
                box-sizing: border-box;
            }
        }
        .filme-another {
            justify-content: flex-end;
            margin-top: .pxToRem(10) [];
        }
        .filme-commission {
            font-size: .pxToRem(22) [];
            color: #000000;
            margin-right: .pxToRem(10) [];
            &-num {
                font-size: .pxToRem(24) [];
                color: #ff1e1e;
            }
        }
    }
</style>
